export default "__VITE_ASSET__BHQOvRUi__"